import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const actions = {
  dmarc: 't(dmarc)',
  forwarded: 't(forwarded)',
  ignored: 't(ignored)',
  ooto: 't(out of office)',
  preview: 't(preview response)',
  subscribed: 't(subscribed)',
  unsubscribed: 't(unsubscribed)'
}

class EmailOutcomeToken extends React.Component {

  static propTypes = {
    email: PropTypes.object
  }

  render() {
    const { email } = this.props
    return (
      <div className="email-interactions-token">
        <ul>
          { email.outcome === 'ignored' ? 
            <li className="bounced">
              <Icon icon="times-circle-o" /> <T text={ actions[email.outcome] } />
            </li> : <li>
              <Icon icon="check-circle-o" /> <T text={ actions[email.outcome] } />
            </li>
          }
        </ul>        
      </div>
    )
  }

}

export default EmailOutcomeToken
